import React, { useState } from 'react'
import { Button, Card, Col, Divider, Flex, Form, Image, Row, Typography } from 'antd'
import { ActionButton, MyInput, MySelect, MySingleFileUpload } from '../../PageComponents'
import { Link } from 'react-router-dom'
import { skills } from '../../../shared'
import { Breadcrumb } from '../../Breadcrumb'
import { AddAppointmentModal } from '../QuoteDrawers'
import { getQuoteData } from '../../../data'

const { Title, Text } = Typography
const GetQuoteForm = () => {
    const [form] = Form.useForm();
    const [ loading, setLoading ] = useState(false)  
    const [showappointment, setShowAppointment] = useState(false)
    const [appointmodal, setAppointModal] = useState(false)
    return (
        <div>
            <Breadcrumb title='Quote Form' pageName='Quote Form' breadcrumb={[{to:'/',name:'Home'}]}/>
            <div className='container padding-t'>   
                <Row gutter={[24,24]} className='mbl-reverse mb-3'>
                    <Col lg={{span: 15}} md={{span: 24}} sm={{span: 24}} xs={{span: 24}}>
                        <Card className='bg-transparent border0 shadow rounded'> 
                            <Flex vertical gap={40}>
                                <Flex vertical gap={10}>
                                    <Title level={1} className='m-0 gradient-text'>
                                        Get a Quote
                                    </Title>
                                    <Text className='text-gray'>
                                        Fill the form below accurately indicating your potentials and suitability to pro applying for.
                                    </Text>
                                </Flex> 
                                <Form
                                    form={form}
                                    layout='vertical'
                                    requiredMark={false}
                                    className='mt-3'
                                >
                                    <Row gutter={[16, 16]}>

                                        <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 12 }}>
                                            <MySelect
                                                label='Choose Service'
                                                name='service'
                                                required
                                                message='Please enter work'
                                                options={skills}
                                                showSearch
                                            />
                                        </Col>
                                        <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 12 }}>
                                            <MySelect
                                                label='Date of project'
                                                name='datepro'
                                                required
                                                message='Please enter date of project'
                                                options={[
                                                    {
                                                        id: 1,
                                                        name: 'Urgent'
                                                    },
                                                    {
                                                        id: 2,
                                                        name: 'Flexible'
                                                    }
                                                ]}
                                            />
                                        </Col>
                                        <Col span={24}>
                                            <MyInput
                                                textArea
                                                label='Project description'
                                                name='projectdesc'
                                                required
                                                message='Please enter project description'
                                                placeholder='write description...'
                                            />
                                        </Col>
                                        <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 12 }}>
                                            <MyInput
                                                label='Budget (min)'
                                                name='budmin'
                                                required
                                                message='Please enter budget (min)'
                                                placeholder=''
                                            />
                                        </Col>
                                        <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 12 }}>
                                            <MyInput
                                                label='Budget (max)'
                                                name='budmax'
                                                required
                                                message='Please enter budget (max)'
                                                placeholder=''
                                            />
                                        </Col>
                                        <Col xs={{ span: 24 }} sm={{ span: 24 }} md={{ span: 24 }} lg={{ span: 24 }}>
                                            <Button className="btn mt-2"
                                                onClick={() => {
                                                    setShowAppointment(true)
                                                }}
                                            >
                                                Choose a Service
                                            </Button>
                                        </Col>
                                        {
                                            showappointment &&
                                            getQuoteData?.map((professional, index) =>
                                                <Col span={12} key={index}>
                                                    <Card className="border-brand">
                                                        <Flex vertical gap={3} className="mb-2">
                                                            <Flex justify="space-between" align="center">
                                                                <Title level={5} className="m-0">
                                                                    {professional?.title}
                                                                </Title>
                                                                <ActionButton
                                                                    title='Add Appointment'
                                                                    className="border0 brown-bg text-white"
                                                                    icon={<img src="/assets/icons/appoint.png"  width={30}/>}
                                                                    onClick={() => setAppointModal(true)}
                                                                />
                                                            </Flex>
                                                            <Text type="secondary" strong className="fs-14">
                                                                {
                                                                    professional?.subtitle
                                                                }
                                                            </Text>
                                                        </Flex>
                                                        <Divider className="my-2" />
                                                        <Row gutter={[16, 12]}>
                                                            {professional?.details?.map((prodetail, i) => (
                                                                <Col span={12} key={i}>
                                                                    <Flex align="center" gap={5}>
                                                                        <div className="fs-16">
                                                                            {prodetail?.icon}
                                                                        </div>
                                                                        <Text className="fs-14">
                                                                            {prodetail?.title}
                                                                        </Text>
                                                                    </Flex>
                                                                </Col>
                                                            ))}
                                                        </Row>
                                                    </Card>

                                                </Col>
                                            )
                                        }
                                    </Row>
                                </Form>
                            </Flex>
                        </Card>
                    </Col>
                    <Col lg={{span: 9}} md={{span: 24}} sm={{span: 24}} xs={{span: 24}}>
                        <Flex vertical gap={0} align='center' className='mt-3'>
                            <Title className='gradient-text'>Quote for a Pro !</Title>
                            <Image src="/assets/images/bid.png" alt="Nextdoor Pros" preview={false} />
                            <Flex className='mt-3' gap={20}>
                                <Link to={'/'}>
                                    <Image src='/assets/icons/twitter.png' width={'30px'} preview={false} />
                                </Link>
                                <Link to={'/'}>
                                    <Image src='/assets/icons/facebook.png' width={'30px'} preview={false} />
                                </Link>
                                <Link to={'/'}>
                                    <Image src='/assets/icons/linkedin.png' width={'30px'} preview={false} />
                                </Link>
                                <Link to={'/'}>
                                    <Image src='/assets/icons/insta.png' width={'30px'} preview={false} />
                                </Link>
                            </Flex>
                        </Flex>
                    </Col>
                </Row>
            </div>
            <AddAppointmentModal
                visible={appointmodal}
                onClose={() => setAppointModal(false)}
            />
        </div>
    )
}

export {GetQuoteForm}